import { keys } from "lodash";

export function getSessionFullUrl(location, session) {
    const { metadata } = session;
    return (`${getFullHostname(location)}/#/play/${metadata && metadata.author}/${metadata && metadata.shortname}`);
}

export function getSessionPartialUrl(session) {
    const { metadata } = session;
    return (`play/${metadata && metadata.author}/${metadata && metadata.shortname}`);
}

export function getFullHostname(location) {
    return (location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : ''));
}

export function getObjectAttrValueAtIndex(obj, index) {
    if (obj == null)
        return (null);
    return (obj[Object.keys(obj)[index]])
}

export function getObjectAttrAtIndex(obj, index) {
    if (obj == null)
        return (null);
    return (Object.keys(obj)[index])
}

export function countObjectKeys(obj) {
    if (obj == null)
        return (0);
    return (keys(obj).length);
}

export const protoString = (proto) => {
    if (proto) {
        if (proto === 'CM') {
            return "Manual Choice"
        } else if (proto === 'MC') {
            return "Multiple Channels"
        } else if (proto === 'MS') {
            return "Multiple Criterias"
        } else if (proto === 'PC') {
            return "Pair Comparison"
        } else {
            return ""
        }
    }
}